import { render, staticRenderFns } from "./hospitalBgmCode.vue?vue&type=template&id=62dec2cc&scoped=true"
import script from "./hospitalBgmCode.vue?vue&type=script&lang=js"
export * from "./hospitalBgmCode.vue?vue&type=script&lang=js"
import style0 from "./hospitalBgmCode.vue?vue&type=style&index=0&id=62dec2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dec2cc",
  null
  
)

export default component.exports